module.exports = __webpack_public_path__ + "img/SY.261a7e0a.svg";